import { render, staticRenderFns } from "./EmployeeDetailsUpdate.vue?vue&type=template&id=5c963554"
import script from "./EmployeeDetailsUpdate.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports